// extracted by mini-css-extract-plugin
module.exports = {"container":"ModifyPersonalDataSuccess_container__2L1z9","msg":"ModifyPersonalDataSuccess_msg__1oYio","confirmBtn":"ModifyPersonalDataSuccess_confirmBtn__3_BmB"};